// Direction artistique (biome) propre à chaque Porte, partagée entre
// la transition torii et l'intérieur de la Porte.
export const BIOMES = {
  1: { name: "Le Feu",      color: "#ff4d1c", glow: "#ffb347", kind: "ember",  motif: "🔥",
       env: "radial-gradient(circle at 50% 15%, #7a1400 0%, #2a0700 55%, #0a0302 100%)" },
  2: { name: "La Vie",      color: "#2fae5f", glow: "#b6f0c2", kind: "leaf",   motif: "🌿",
       env: "radial-gradient(circle at 50% 15%, #0f5a2e 0%, #08331b 55%, #04150c 100%)" },
  3: { name: "Les Masques", color: "#e11d2a", glow: "#ff8a8a", kind: "oni",    motif: "👹",
       env: "radial-gradient(circle at 50% 15%, #6e0710 0%, #2a0207 55%, #100103 100%)" },
  4: { name: "Le Fil",      color: "#2f7bff", glow: "#a9cbff", kind: "thread", motif: "🧵",
       env: "radial-gradient(circle at 50% 15%, #0a2f6e 0%, #05173a 55%, #020a1c 100%)" },
  5: { name: "Les Racines", color: "#9b5cf6", glow: "#d6c2ff", kind: "root",   motif: "🌱",
       env: "radial-gradient(circle at 50% 15%, #3d1a6e 0%, #200c3a 55%, #0e0520 100%)" },
  6: { name: "Le Courage",  color: "#f4b400", glow: "#fff0b3", kind: "spark",  motif: "⚡",
       env: "radial-gradient(circle at 50% 15%, #7a5400 0%, #2e2000 55%, #120c00 100%)" },
  7: { name: "L'Appel",     color: "#1fb0a6", glow: "#bff5ee", kind: "wave",   motif: "🌊",
       env: "radial-gradient(circle at 50% 15%, #0a5f66 0%, #043238 55%, #01161a 100%)" },
};

export const biomeFor = (index) => BIOMES[index] || BIOMES[1];
